export const KV = {
  APP_ID: 'app_id',
  THIRD_PARTY_USER_ID: 'third_party_user_id',
  CLIENT: 'client',
  ACCESS_TOKEN: 'access_token',
  PACKAGE_CHECK: 'package_check',
  ATTRIBUTE_ID: 'attribute_id',
  BUCKET: 'bucket',
  REGION: 'region',
  ACCESSKEYID: 'AccessKeyId',
  ACCESSKEYSECRET: 'AccessKeySecret',
  SECURITYTOKEN: 'SecurityToken',
  CLIENT_TYPE: 'type',
  PREFIX: 'demand_prefix'
};

export const EVENT = {
  FILE_LIST_REPEAT: 'FILE_LIST_REPEAT', // 重复文件选择
  FILE_CHECK_ERROR: 'FILE_CHECK_ERROR', // 重复文件选择
  FILE_UPLOAD_EXISTS: 'FILE_UPLOAD_EXISTS', // 服务器中存在相同文件
  FILE_UPLOAD_PROGRESS: 'FILE_UPLOAD_PROGRESS', // 文件上传进度更新
  FILE_UPLOAD_SUCCESS: 'FILE_UPLOAD_SUCCESS', // 文件上传成功
  FILE_UPLOAD_FAIL: 'FILE_UPLOAD_FAIL', // 文件上传失败
  //
  UPLOAD_TASK_DRAIN: 'UPLOAD_TASK_DRAIN', // 任务列表所有文件上传完成
  UPLOAD_TASK_PAUSE: 'UPLOAD_TASK_PAUSE', // 任务列表上传暂停
  UPLOAD_TASK_RESUME: 'UPLOAD_TASK_RESUME' // 任务列表上传恢复
};

export const API_URL = {
  CREAT_DEMAND: '/sdk/v2/demand/create-demand',
  CREAT_SUBTITLE: '/sdk/v2/demand/create-subtitle',
  GET_AUTH: '/sdk/v2/demand/upload-auth-key'
};

export const CLIENT_API = {
  QUERY_FILE: '/sdk/v2/vodstorage/query-files-tatus',
  UPLOAD_FILE: '/sdk/v2/vodstorage/upload-file',
  DELET_FILE: '/sdk/v2/vodstorage/delete-file'
};
